import React, {useEffect} from 'react'
import { connect } from 'react-redux'
import GradedSmiley from './GradedSmiley'
import { getStarsJSX, setBusinessSorting, updateTable } from './redux/FeedbackRedux'

const Row = ({
    business_row_name,
    totalFeedbacksURL,
    openFeedbacksURL,
    pendingFeedbacksURL,
    resolvedFeedbacksURL,
    ratingsOnlyFeedbacksURL,
    chatsRequestedURL,
    chatsStartedURL,
    is_bold = false,
    showNotes = true,
    showStatus = true,
    showIndustry = true,
    ...value
  }) => {

    const calcAIScore = (value) => {
        let score;
        if (value !== undefined) {
            score = value < 50
                ? 'text-danger'
                : value < 65
                    ? 'text-warning'
                    : 'text-success';
        }
        return score
    }

    let color;
		switch (true) {
			case value.smiley_score >= 85:
				color = '#01de1c';
				break;
			case value.smiley_score >= 70 && value.smiley_score < 85:
				color = '#33f502';
				break;
			case value.smiley_score >= 55 && value.smiley_score < 70:
				color = '#8cc704';
				break;
			case value.smiley_score >= 45 && value.smiley_score < 55:
				color = '#888888';
				break;
			case value.smiley_score >= 30 && value.smiley_score < 45:
				color = '#ffcf08';
				break;
			case value.smiley_score >= 15 && value.smiley_score < 30:
				color = '#fe0100';
				break;
			case value.smiley_score >= 0 && value.smiley_score < 15:
				color = '#b30101';
				break;
			default:
				color = ''; // Handle any other cases as needed
		}

    // Data Mapping
    const data = {
        "total_feedbacks_without_ratings_only": value.totalFeedbacksWithoutRatingsOnly || 0,
        "open": value.Open,
        "pending": value.Pending,
        "resolved": value.Resolved,
        "ratingsOnly": value.RatingsOnly,
        "chats_requested": value.chatsRequested,
        "chats_started": value.chatsStarted,
        "smiley_score": value.smileyScore,
        "AIScore": value.sentimentScore,
        "median_response_time": value.medianResponseTime || 0,
        "avg_ratethisbiz": parseFloat(value.averageRating) || 0,
        "industryName": value.industryName,
        "notes:": value.notes,
        "businessStatus": window.businessStatus[value.businessStatus]?.label || value.businessStatus
    }

    return (
        <div className="row ml-0 mr-0">
            {showNotes &&
                <div className="col-1 col-1--narrow d-flex align-items-center">
                    {value.notes?.length > 0 &&
                        <div className="tooltip-text w-100 h-100 d-flex align-items-center justify-content-center"
                             data-toggle="tooltip"
                             data-placement="top"
                             data-title={value.notes}
                             title={value.notes}
                        >
                        <svg
                            className='notes-icon'
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path d="M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"/>
                        </svg>
                        </div>
                    }
                </div>
            }

            <div className={`d-flex flex-row col-1 col-1--narrow ${is_bold ? 'font-bold' : ''}`}>
                <span>{business_row_name}</span>
            </div>

            {showStatus &&
                <div className="col-1 col-1--narrow">{data.businessStatus ? data.businessStatus : 'N/A'}</div>
            }

            {showIndustry &&
                <div className="col-1 col-1--narrow">{data.industryName ? data.industryName : 'N/A'}</div>
            }

            {/* total feedbacks */}
            <div className="col-1 col-1--narrow">
              <MakeNumberLinkOrText number={data.total_feedbacks_without_ratings_only} link={totalFeedbacksURL?.feedbacksUrl} />
            </div>

            {/* open feedbacks */}
            <div className="col-1 col-1--narrow">
              <MakeNumberLinkOrText number={data.open} link={openFeedbacksURL?.feedbacksUrl} />
            </div>

            {/* pending feedbacks */}
            <div className="col-1 col-1--narrow">
              <MakeNumberLinkOrText number={data.pending} link={pendingFeedbacksURL?.feedbacksUrl} />
            </div>

            {/* resolved feedbacks */}
            <div className="col-1 col-1--narrow">
              <MakeNumberLinkOrText number={data.resolved} link={resolvedFeedbacksURL?.feedbacksUrl} />
            </div>

            {/* RatingsOnly feedbacks */}
            <div className="col-1 col-1--narrow">
              <MakeNumberLinkOrText number={data.ratingsOnly} link={ratingsOnlyFeedbacksURL?.feedbacksUrl} />
            </div>

            {/* chats requested */}
            <div className="col-1 col-1--narrow">
              <MakeNumberLinkOrText number={data.chats_requested} link={chatsRequestedURL?.feedbacksUrl} />
            </div>

            {/* chats started */}
            <div className="col-1 col-1--narrow">
              <MakeNumberLinkOrText number={data.chats_started} link={chatsStartedURL?.feedbacksUrl} />
            </div>

            {/* Smiley Score */}
            <div className="col-1 col-1--narrow">
              {(data.smiley_score !== null && data.smiley_score !== 0)
                ?
                  <span style={{'color':color, 'whiteSpace':'nowrap'}}>
                    <GradedSmiley smiley_score={data.smiley_score} /> {data.smiley_score}  %
                  </span>
                :
                  <span>
                    { __('No Data') }
                  </span>
              }
            </div>

            {/* AI Sentiment Score */}
            <div className={calcAIScore(data.AIScore) + " col-1"}>
              {data.AIScore ? data.AIScore+"%" : __("No Data")}
            </div>

            {/* Median Resp Time */}
            <div className="col-1">
              <span>
                { data && data.median_response_time !== 0 && data.median_response_time
                  ? data?.median_response_time?.formatted
                  : "No Data"
                }
              </span>
            </div>

            {/* Rating */}
            <div className="col-1 col-1--narrow">
              <span data-time={data.avg_ratethisbiz}>
              {data
                ? (data.avg_ratethisbiz && data.avg_ratethisbiz !== 0)
                  ? <span>
                      <span className="mr-1 d-block">{data?.avg_ratethisbiz?.toFixed(2)}</span>
                      <span className="font-10px">
                          {getStarsJSX(data.avg_ratethisbiz, "OTF", true)}
                      </span>
                    </span>
                  : "No Data"
                : "No Data"
              }
              </span>
            </div>
        </div>
    );
  };

  const MakeNumberLinkOrText = ({ number, link }) => {
      const parsedNumber = parseInt(number, 10);

      // If the parsed number is greater than 0, render the link; otherwise, render a span.
      if (!isNaN(parsedNumber) && parsedNumber >= 0) {
          return (
              <a href={link} target="_blank">{parsedNumber.toLocaleString()}</a>
          );
      } else {
          return <span>{'N/A'}</span>;
      }
  }

  const SortIcon = () => {
    return (
      <div className="table-header-sort-icons">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg>
      </div>
    );
  };

  // Sortable Table Dashboard
  class SortableTableDashboard extends React.Component {
    constructor(props) {
      super(props);

      const business_sorting = window.localStorage.getItem("business_sorting") ?? 'businessname asc';

      this.state = {
        data: this.props.stats_table,
        fetchStatisticsData: this.props.fetchStatisticsData,
        fetchTotalsData: this.props.fetchTotalsData,
        sortDirection: business_sorting.split(' ')[1],
        sortKey: business_sorting.split(' ')[0],
        currentPage: 1,
        itemsPerPage: 10,
        selectedIndustry: 'All',
        searchQuery: '',
        filteredItems: this.props.fetchStatisticsData || [],
        showNotes: this.props.showNotes !== undefined ? this.props.showNotes : true,
        showStatus: this.props.showStatus !== undefined ? this.props.showStatus : true,
        showIndustry: this.props.showIndustry !== undefined ? this.props.showIndustry : true,
      };
    }

      componentDidUpdate(prevProps, prevState) {
          if (prevProps.fetchStatisticsData !== this.props.fetchStatisticsData) {
              this.updateFilteredItems();
          }

          // Only update filteredItems if searchQuery, selectedIndustry, or sorting changed
          if (prevState.searchQuery !== this.state.searchQuery ||
              prevState.selectedIndustry !== this.state.selectedIndustry ||
              prevState.sortKey !== this.state.sortKey ||
              prevState.sortDirection !== this.state.sortDirection)
          {
              this.updateFilteredItems();
          }

          // init debt tooltip
          $('[data-toggle="tooltip"]').each(function() {
              jQuery(this).tooltip({
                  html: true,
                  container: 'body',
                  boundary: 'window'
              });
          });
      }

      // Function to filter and update filteredItems based on search, industry, and sorting
      updateFilteredItems() {
          let filteredItems = this.props.fetchStatisticsData
              ? Object.values(this.props.fetchStatisticsData).filter(item => {
                  return this.state.selectedIndustry === 'All' || item.industryName === this.state.selectedIndustry;
              })
              : [];

          filteredItems = filteredItems.filter(item => {
              return item.businessName.toLowerCase().includes(this.state.searchQuery.toLowerCase());
          });

          // Apply sorting to the filtered data
          filteredItems.sort((a, b) => {
              const comparator = this.state.sortDirection === 'asc' ? this.compareBy(this.state.sortKey) : (x, y) => -this.compareBy(this.state.sortKey)(x, y);
              return comparator(a, b);
          });

          // Update state with the filtered and sorted items
          this.setState({ filteredItems });
      }

      handlePageChange = (pageNumber) => {
          this.setState({ currentPage: pageNumber });
      }

      handleItemsPerPageChange = (event) => {
          this.setState({ itemsPerPage: parseInt(event.target.value, 10), currentPage: 1 });
      }

      handleSearchChange = (event) => {
          this.setState({
              searchQuery: event.target.value,
              currentPage: 1 // Reset to first page when the search query changes
          });
      }

      handleIndustryChange = (event) => {
          this.setState({ selectedIndustry: event.target.value });
      }

    compareBy(key) {
        // Split the key by '.' to handle nested properties
        const keys = key.split('.');

        // Return a function that accesses nested properties and compares them
        return (a, b) => {
            let aValue = a;
            let bValue = b;

            // Access nested properties
            for (const nestedKey of keys) {
                if (aValue && aValue[nestedKey] !== undefined) {
                    aValue = aValue[nestedKey];
                } else {
                    aValue = null; // If any key doesn't exist, set the value to null
                    break; // Exit loop early
                }

                if (bValue && bValue[nestedKey] !== undefined) {
                    bValue = bValue[nestedKey];
                } else {
                    bValue = null; // If any key doesn't exist, set the value to null
                    break; // Exit loop early
                }
            }

            // Perform comparison
            if (aValue === null && bValue === null) return 0;
            if (aValue === null) return -1; // Null values come first
            if (bValue === null) return 1; // Null values come last
            if (aValue < bValue) return -1;
            if (aValue > bValue) return 1;
            return 0;
        };
    };

    sortBy(key) {
          // Toggle sorting direction based on current state
          const isAscending = this.state.sortDirection === 'asc';

          // Sort the filtered items, not the entire fetchStatisticsData
          let arrayCopy = [...this.state.filteredItems]; // Use filteredItems for sorting

          // Sort the copied array based on the given key and sorting direction
          arrayCopy.sort((a, b) => {
              const comparator = isAscending ? this.compareBy(key) : (x, y) => -this.compareBy(key)(x, y);
              return comparator(a, b);
          });

          // Update state with the sorted data and toggle sorting direction
          this.setState({
              filteredItems: arrayCopy,  // Update filteredItems with the sorted array
              sortDirection: isAscending ? 'desc' : 'asc', // Toggle the sorting direction
              sortKey: key // Set the sorting key to the clicked column
          });

          // Update business sorting for external use if necessary
          this.props.setBusinessSorting(`${key} ${isAscending ? 'desc' : 'asc'}`);
      }

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
    }

    handleItemsPerPageChange = (event) => {
        this.setState({ itemsPerPage: parseInt(event.target.value, 10), currentPage: 1 });
    }

    render() {
        const { currentPage, itemsPerPage, filteredItems } = this.state;

        // Pagination logic
        const totalPages = Math.ceil(filteredItems.length / itemsPerPage) || 1;
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = Array.isArray(filteredItems) ? filteredItems.slice(indexOfFirstItem, indexOfLastItem) : [];

      // generate business location and URL
      const generateBusinessRowName = (base_url, value, is_super_user) => {
        let business_row_name;
        if (is_super_user) {
          business_row_name = <a href={"/view-as-business/login/" + value.business_id + "/dashboard"} target="_blank">{value.businessName}</a>;
        } else {
          business_row_name = <a href={"/business/" + value.business_id + "/company-profile"} target="_blank">{value.businessName}</a>;
        }
        return business_row_name;
      };

      // generate total feedbacks URL
      const generateFeedbacksURL = (base_url, feedbackStatus, chats = null) => {
        let others = chats ? chats : this.props.other;

        let url = base_url + '/timeframe/' + this.props.timeframe + '/status/' + feedbackStatus + '/other/' + others;
        if (window.feedbackStatus.RatingsOnly.value === feedbackStatus) {
            url = url + '?filterRating=1,2,3,4,5';
        }

        return {
          feedbacksUrl: url
        };
      }

        // Handle industry filter change
        const handleIndustryChange = (event) => {
            const selected = event.target.value;
            this.setState({ selectedIndustry: selected });
        };

        const handleSearchChange = (event) => {
            const query = event.target.value;
            this.setState({
                searchQuery: query,
                currentPage: 1 // Reset to first page when the search query changes
            });
        };

      return (
          <div className="col-xl-12 table table-min-1200">
              <div className="table-footer d-flex flex-row justify-content-start align-items-between my-3">
                  <div className="d-flex flex-row mr-4 justify-content-center align-items-center">
                      <span className="mr-2 text-nowrap">{ __('Search Location') }:</span>
                      <input
                          type="search"
                          className="d-block w-100 search-business"
                          value={this.state.searchQuery}
                          onChange={handleSearchChange}
                          placeholder="Search"
                      />
                  </div>

                  {this.state.showIndustry &&
                      <div className="d-flex flex-row mr-4 justify-content-center align-items-center">
                          <span className="mr-2">{ __('Filter by Industry') }:</span>
                          <select className="d-block select-industry" onChange={handleIndustryChange}>
                              <option value="All">{ __('All') }</option>
                              {Array.from(new Set(this.props.fetchStatisticsData.map(item => item.industryName))) // Unique industries
                                  .map((industry, index) => (
                                      <option key={index} value={industry}>{industry}</option> // Display each industry as an option
                                  ))
                              }
                          </select>
                      </div>
                  }

                  <div className="d-flex flex-row mr-4 justify-content-center align-items-center">
                      {/* Items Per Page*/}
                      <div className="d-block items-per-page">
                          <label className="m-0 mr-1" htmlFor="itemsPerPage">{ __('Items per page') }:</label>
                          <select id="itemsPerPage" value={itemsPerPage} onChange={this.handleItemsPerPageChange}>
                              <option value={10}>10</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                              <option value={100}>100</option>
                          </select>
                      </div>
                  </div>

                  <div className="d-flex flex-row justify-content-center align-items-center">
                      {/* Pagination */}
                      <div className="d-flex flex-row mr-3 pagination">
                          <span>{ __('Pagination') }:</span>
                          {currentPage !== 1 &&
                              <>
                                  {/* "First" button */}
                                  <button onClick={() => this.handlePageChange(1)}>
                                      { __('First') }
                                  </button>


                                  {/* "Prev" button */}
                                  <button onClick={() => this.handlePageChange(currentPage - 1)}>
                                      &#8592;
                                  </button>
                              </>
                          }


                          {/* Pagination numbers */}
                          {totalPages > 5 && currentPage > 3 && (
                              <button
                                  onClick={() => this.handlePageChange(1)}
                                  className={currentPage === 1 ? 'active' : ''}
                              >
                                  1
                              </button>
                          )}
                          {totalPages > 5 && currentPage > 4 && <span>...</span>}

                          {Array.from({ length: totalPages }, (_, index) => {
                              const page = index + 1;
                              if (page >= currentPage - 2 && page <= currentPage + 2) {
                                  return (
                                      <button
                                          key={index}
                                          onClick={() => this.handlePageChange(page)}
                                          className={currentPage === page ? 'active' : ''}
                                      >
                                          {page}
                                      </button>
                                  );
                              }
                              return null;
                          })}

                          {totalPages > 5 && currentPage < totalPages - 3 && <span>...</span>}
                          {totalPages > 5 && currentPage < totalPages - 2 && (
                              <button
                                  onClick={() => this.handlePageChange(totalPages)}
                                  className={currentPage === totalPages ? 'active' : ''}
                              >
                                  {totalPages}
                              </button>
                          )}

                          {/* Next button */}
                          {currentPage !== totalPages &&
                              <>
                                  {/* "Next" button */}
                                  <button onClick={() => this.handlePageChange(currentPage + 1)}>
                                      &#8594;
                                  </button>

                                  {/* "Last" button */}
                                  <button onClick={() => this.handlePageChange(totalPages)}>
                                      { __('Last') }
                                  </button>
                              </>
                          }
                      </div>
                  </div>
              </div>

              {/* Table Head */}
              <div className="table-header row ml-0 mr-0">
                  {this.state.showNotes &&
                      <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'notes'}>
                          <div className="table-header-label-wrapper">
                              <span onClick={() => this.sortBy('notes')}>{ __('Notes') }</span>
                              <SortIcon onClick={() => this.sortBy('notes')} />
                          </div>
                      </div>
                  }

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'businessname'}>
                    <div className="table-header-label-wrapper">
                      <span onClick={() => this.sortBy('businessname')}>{ __('Location') }</span>
                      <SortIcon onClick={() => this.sortBy('businessname')} />
                    </div>
                  </div>

                  {this.state.showStatus &&
                      <div className="col-1 col-1--narrow">
                          <div className="table-header-label-wrapper">
                              <span onClick={() => this.sortBy('businessStatus')}>{ __('Status') }</span>
                              <SortIcon onClick={() => this.sortBy('businessStatus')} />
                          </div>
                      </div>
                  }

                  {this.state.showIndustry &&
                      <div className="col-1 col-1--narrow">
                          <div className="table-header-label-wrapper">
                              <span>{ __('Industry') }</span>
                          </div>
                      </div>
                  }

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'totalFeedbacksWithoutRatingsOnly'} onClick={() => this.sortBy('totalFeedbacksWithoutRatingsOnly')}>
                    <div className="table-header-label-wrapper">
                      <span>{ __('Feedbacks') }</span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'Open'} onClick={() => this.sortBy('Open')}>
                    <div className="table-header-label-wrapper">
                      <span>{window.feedbackStatus.Open.label}</span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'Pending'} onClick={() => this.sortBy('Pending')}>
                    <div className="table-header-label-wrapper">
                      <span>{window.feedbackStatus.Pending.label}</span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'Resolved'} onClick={() => this.sortBy('Resolved')}>
                    <div className="table-header-label-wrapper">
                      <span>{window.feedbackStatus.Resolved.label}</span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'RatingsOnly'} onClick={() => this.sortBy('RatingsOnly')}>
                    <div className="table-header-label-wrapper">
                      <span>{window.feedbackStatus.RatingsOnly.label}</span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'chatsRequested'} onClick={() => this.sortBy('chatsRequested')}>
                    <div className="table-header-label-wrapper">
                      <span>{ __('Chats Requested') }</span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'chatsStarted'} onClick={() => this.sortBy('chatsStarted')}>
                    <div className="table-header-label-wrapper">
                      <span>{ __('Chats Started') }</span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'smileyScore'} onClick={() => this.sortBy('smileyScore')}>
                    <div className="table-header-label-wrapper">
                      <span>
                        { __('Smiley Score') }
                        <i className="far fa-question-circle text-muted ml-1" data-toggle="tooltip" data-placement="top" data-title={ __("Your Smiley Score is the average of the smiley ratings selected by your customers when submitting Feedbacks. The scores range from 0% (very negative exerience) to 100% (very positive experience) and are color-coded as follows:") + "<img src='/img/smiley-scale.png' style='width:100%; border-radius: 5px;' />"}></i>
                      </span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'sentimentScore'} onClick={() => this.sortBy('sentimentScore')}>
                    <div className="table-header-label-wrapper">
                      <span>
                        { __('AI Sentiment Score') }
                        <i className="far fa-question-circle text-muted ml-1" data-toggle="tooltip" data-placement="top" data-title={__("Feedback uses Artificial Intelligence to automatically scan Feedbacks to assess your customers' positive and negative language and emotions. The AI Sentiment Score is graded on a scale of 0% (very negative) to 100% (very positive).")}></i>
                      </span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'medianResponseTime.seconds'} onClick={() => this.sortBy('medianResponseTime.seconds')}>
                    <div className="table-header-label-wrapper">
                      <span>{ __('Median Resp Time') }</span>
                      <SortIcon />
                    </div>
                  </div>

                  <div className="col-1 col-1--narrow" data-sort={this.state.sortDirection} data-issorted={this.state.sortKey === 'averageRating'} onClick={() => this.sortBy('averageRating')}>
                    <div className="table-header-label-wrapper">
                      <span>{__('Ratings')}</span>
                      <SortIcon />
                    </div>
                  </div>
              </div>

              {/* Table Body - Rows */}
              <div className="table-body">
                {/* {rows} */}
                {currentItems.length > 0
                    ? currentItems.map((value, index) => {

                      // base URL
                      var base_url = "#";
                      if (value.link_type && value.link_type === 'business') {
                        if(value.region_id) {
                            base_url = "/business/" + value.business_id + "/feedbacks/" + this.props.state_region.region_type + "/" + this.props.state_region.region_id;
                        } else {
                            base_url = "/business/" + value.business_id + "/feedbacks";
                        }
                      } else if (value.link_type && value.link_type === 'businessgroup'){
                          base_url = "/business/" + value.business_id + "/feedbacks";
                      } else if (value.link_type && value.link_type === 'region'){
                        if(value.region_id) {
                            base_url = "/dashboard/region/"+value.region_id;
                        }
                      } else {
                          if(this.props?.state_region?.region_id){
                              base_url = "/business/" + value.business_id + "/feedbacks/" + this.props.state_region.region_type + "/" + this.props.state_region.region_id;
                          } else {
                              base_url = "/business/" + value.business_id + "/feedbacks";
                          }
                      }

                      return (
                        <Row
                          key={index}
                          {...value}
                          business_row_name={generateBusinessRowName(base_url, value, this.props.is_super_user)}
                          totalFeedbacksURL={generateFeedbacksURL(base_url, "All")}
                          openFeedbacksURL={generateFeedbacksURL(base_url, "Open")}
                          pendingFeedbacksURL={generateFeedbacksURL(base_url, "Pending")}
                          resolvedFeedbacksURL={generateFeedbacksURL(base_url, "Resolved")}
                          ratingsOnlyFeedbacksURL={generateFeedbacksURL(base_url, "RatingsOnly")}
                          chatsRequestedURL={generateFeedbacksURL(base_url, "All", "chats_requested")}
                          chatsStartedURL={generateFeedbacksURL(base_url, "All", "chats_started")}
                          showNotes={this.state.showNotes}
                          showStatus={this.state.showStatus}
                          showIndustry={this.state.showIndustry}
                        />
                      )
                    }
                    ) : (
                        <h2 className='d-block text-center w-100 text-no-results'>{__('No Items Found')}.</h2>
                    )
                }

                {/* totals */}
                {this.props.fetchTotalsData &&
                  <Row
                    {...this.props.fetchTotalsData}
                    business_row_name={`${this.props.fetchTotalsData?.totalBusinesses} ${this.props.fetchTotalsData?.totalBusinesses > 1 ? __('Locations') : __('Location')}`}
                    is_bold={true}
                    showNotes={this.state.showNotes}
                    showStatus={this.state.showStatus}
                    showIndustry={this.state.showIndustry}
                  />
                }
              </div>

              <div className="table-footer d-flex flex-row align-items-center justify-content-end">
                  {/* Pagination */}
                  <div className="d-flex flex-row mr-3 pagination">
                      {currentPage !== 1 &&
                          <>
                              {/* "First" button */}
                              <button onClick={() => this.handlePageChange(1)}>
                                  { __('First') }
                              </button>


                              {/* "Prev" button */}
                              <button onClick={() => this.handlePageChange(currentPage - 1)}>
                                  &#8592;
                              </button>
                          </>
                      }


                      {/* Pagination numbers */}
                      {totalPages > 5 && currentPage > 3 && (
                          <button
                              onClick={() => this.handlePageChange(1)}
                              className={currentPage === 1 ? 'active' : ''}
                          >
                              1
                          </button>
                      )}
                      {totalPages > 5 && currentPage > 4 && <span>...</span>}

                      {Array.from({ length: totalPages }, (_, index) => {
                          const page = index + 1;
                          if (page >= currentPage - 2 && page <= currentPage + 2) {
                              return (
                                  <button
                                      key={index}
                                      onClick={() => this.handlePageChange(page)}
                                      className={currentPage === page ? 'active' : ''}
                                  >
                                      {page}
                                  </button>
                              );
                          }
                          return null;
                      })}

                      {totalPages > 5 && currentPage < totalPages - 3 && <span>...</span>}
                      {totalPages > 5 && currentPage < totalPages - 2 && (
                          <button
                              onClick={() => this.handlePageChange(totalPages)}
                              className={currentPage === totalPages ? 'active' : ''}
                          >
                              {totalPages}
                          </button>
                      )}

                      {/* Next button */}
                      {currentPage !== totalPages &&
                          <>
                              {/* "Next" button */}
                              <button onClick={() => this.handlePageChange(currentPage + 1)}>
                                  &#8594;
                              </button>

                              {/* "Last" button */}
                              <button onClick={() => this.handlePageChange(totalPages)}>
                                  { __('Last') }
                              </button>
                          </>
                      }
                  </div>
              </div>
          </div>
      );
    }
}

function mapStateToProps(state) {
	return {
    state: state,
    stats_table: state.stats_table,
    state_region: (state.region && state.region_type ? {region_type: state.region_type, region_id: state.region.id} : null),
    business: state.business ?? null,
    timeframe: state.timeframe,
    other: state.other_filter,
    totals: state.totals
  }
}
function mapDispatchToProps(dispatch) {
    return {
        updateStatsTable: (data) => {
            dispatch(updateTable(data));
        },
        setBusinessSorting: (data) => {
            dispatch(setBusinessSorting(data));
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SortableTableDashboard);
